import React from 'react';
import { Typography, TypographyProps } from '../../../../../components/Typography';
import { Box } from '../../../../../wag-react/next-components/box';
export type VetProfileCardSpecializationTextProps = TypographyProps;
export const VetProfileCardSpecializationText = (props: VetProfileCardSpecializationTextProps) => <Box overflow="hidden" my={['8px', '16px']} data-sentry-element="Box" data-sentry-component="VetProfileCardSpecializationText" data-sentry-source-file="VetProfileCardSpecializationText.tsx">
    <Typography variant="body1" color="white" m={0} mr="-50px" pr="50px" style={{
    height: '100%',
    overflowY: 'scroll'
  }} {...props} data-sentry-element="Typography" data-sentry-source-file="VetProfileCardSpecializationText.tsx" />
  </Box>;